export default {
    // banner
    'game.banner.title': 'We Are A Gaming Studio!',
    'game.banner.description': `Gorilla is a game studio dedicated to creating timeless interactive entertainment that inspires human connections worldwide.`,
    'game.content.declare': "Developed Products",
    
    // content 1
    'game.content1.game1.title': 'Archero',
    'game.content1.game1.desc': `BE A HERO!`,
    'game.content1.game1.buttonText': 'Read More',

    'game.content1.game3.title': 'Punball',
    'game.content1.game3.desc': `AIM, SHOOT, BOUNCE!`,
    'game.content1.game3.buttonText': 'Read More',

    'game.content1.game8.title': 'Survivor.io',
    'game.content1.game8.desc': `SURVIVE THE FUN!`,
    'game.content1.game8.buttonText': 'Read More',

    'game.content1.game14.title': 'Capybara Go!',
    'game.content1.game14.desc': `Love capybaras so much you want to play as one?`,
    'game.content1.game14.buttonText': 'Read More',

    'game.content1.game15.title': 'Archero2',
    'game.content1.game15.desc': `Join 200 million players in unlocking the memories of the archer!`,
    'game.content1.game15.buttonText': 'Read More',

    'game.content1.game12.title': 'Coming Soon'
};
